import { combineReducers, configureStore } from '@reduxjs/toolkit';
import type { Action, ThunkAction } from '@reduxjs/toolkit'
import appDetailReducer from './AppDetails/AppDetailsSlice';
import trialsReducer from './Trials/TrialsSlice';
import trialLocationReducer  from "./TrialLocation/TrialLocationSlice";
import userReducer  from "./User/UserSlice";
import dataCollectionReducer  from "./DataCollection/DataCollectionSlice";
import loadingReducer  from "./Loading/LoadingSlice";
import totalRecordsCount  from "./TotalRecordsCount/TotalRecordsCountSlice";
import userPreferencesReducer from './UserPreferences/UserPreferencesSlice';
import ReportingReducer from './Reporting/ReportingSlice';
import MasterCatalogReducer from './MasterCatalog/MasterCatalogSlice';
import unSavedChangesReducer from './UnSavedChangesSlice/UnSavedChangesSlice';

import {  persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['loading','totalRecordsCount', 'unSavedChanges'],
};
const rootReducer = combineReducers({
  appDetails: appDetailReducer, // Your reducers go here
  trials:trialsReducer,
  trialLocation:trialLocationReducer,
  user: userReducer,
  dataCollection:dataCollectionReducer,
  loading:loadingReducer,
  totalRecordsCount:totalRecordsCount,
  userPreferences:userPreferencesReducer,
  reporting: ReportingReducer,
  masterCatalog: MasterCatalogReducer,
  unSavedChanges:unSavedChangesReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: persistedReducer,
})

// Infer the type of `store`
export type AppStore = typeof store
export const persistor = persistStore(store);
export type RootState = ReturnType<AppStore['getState']>
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore['dispatch']
// Define a reusable type describing thunk functions
export type AppThunk<ThunkReturnType = void> = ThunkAction<
  ThunkReturnType,
  RootState,
  unknown,
  Action
>